import type { ButtonHTMLAttributes, ReactNode } from 'react'

import styles from './ChoiceCard.module.css'

export interface ChoiceCardProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  selected?: boolean
  icon: ReactNode
  title: ReactNode
  subtitle: ReactNode
  unit: ReactNode
}

export function ChoiceCard({ selected = false, icon, title, subtitle, unit, className = '', ...props }: ChoiceCardProps) {
  return (
    <button type="button" className={`${styles.choice} ${selected ? styles.selected : ''} ${className}`} {...props}>
      <div className={styles.top}><span className={styles.icon}>{icon}</span><span className={styles.name}>{title}</span></div>
      <p className={styles.subtitle}>{subtitle}</p>
      <p className={styles.unit}>{unit}</p>
    </button>
  )
}
